import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'
import {devices,owners,contracts,geofences,types,filterdata,reFilterDevices} from '@/app/reports/share/helper'

export default function reportForm() {

  const  areas_owners=ref([]);
  const  areas_contracts=ref([]);

  
  const types=ref([
    {id:"all",name:"all"},
     {id:"deviceOnline",name:"deviceOnline"},
     {id:"deviceUnknown",name:"deviceUnknown"},
     {id:"deviceOffline",name:"deviceOffline"},
     {id:"ignitionOn",name:"ignitionOn"},
     {id:"ignitionOff",name:"ignitionOff"},
     {id:"deviceMoving",name:"deviceMoving"},
     {id:"deviceStopped",name:"deviceStopped"},
     {id:"geofenceEnter",name:"geofenceEnter"},
     {id:"geofenceExit",name:"geofenceExit"},
     {id:"alarm",name:"alarm"},
     {id:"maintenance",name:"maintenance"}
    
  ]);


 
  


  ReportService.getDevicesOptions({
    type:'user',
  
    user: store.state.auth.userData.id,
    isOwner:true
  }).then(response =>{ 
    areas_owners.value = response.data;
    owners.value = response.data;
  })


  
  ReportService.getDevicesOptions({
    type:'contract',
    user: store.state.auth.userData.id
  }).then(response =>{
 
    areas_contracts.value = response.data
  contracts.value = response.data

})

ReportService.getDevicesOptions({
  type:'device',
  user: store.state.auth.userData.id
}).then(response =>{

  devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))


})

  ReportService.getDevicesOptions({
    type:'geofence',
    user: store.state.auth.userData.id
  }).then(response =>{
   
  
    geofences.value =  response.data.map((d)=>({id:d.geofence_id,"name":d.name}))
  
  })
  
 



  return {
    devices,
    owners,
    contracts,
    geofences,
    types,
    reFilterDevices,
    filterdata,
    areas_owners,
    areas_contracts,
  }

}
